import { Text } from "theme-ui";
import DisplayCSSPropertyMatrixData from "../../../../documentation/data/text.yaml";
import * as React from 'react';
export default {
  Text,
  DisplayCSSPropertyMatrixData,
  React
};